module.exports = __webpack_public_path__ + "img/palas_padel.7a5e96f4.jpg";